const people = {
    JillianMurray: {
        title: 'Putting relationships at the centre',
        body: [
            `<em class=em>What if the future is built on more human connection, not less? We're proud to provide a workplace where relationships matter.</em>`,
            `Whether it’s helping a client meet a deadline, providing a colleague with feedback to help them grow, or creating a sustainable impact in our communities, relationships are at the forefront of what we do.`,
            `For Jillian Murray, who’s been at Doane Grant Thornton for 21 years, relationships are what matter most. “We all go to work every day for the people,” she says. “Whether that’s your clients or your colleagues, they’re what make the experience meaningful.”
            In her role on the Doane Grant Thornton Foundation Board, Jillian connects with people across the firm by helping them discover charities that the Foundation can support. The Foundation’s impact on charities is impressive—with over 140 organizations across 60 communities receiving donations in 2023.`,
            `“It’s a great opportunity to use another part of my brain and see how we can direct our hard work towards supporting people in communities where we live and work.”`,
            `She’s also proud to be part of Doane Grant Thornton’s commitment to coaching others. “It’s not about managing, but about helping people see their potential. I’ve been here a long time and I’ve witnessed people grow and change and then pass those skills on. We all feel like we’re part of something bigger, and that the people we work with have our back. That feeling permeates throughout the firm.”`,
            `And, she says, we also know how to have fun. “There’s not one person here that you wouldn’t want to have dinner with. My husband is always amazed that after a week of working together, we choose to get together on the weekends too. But that’s the kind of culture we’ve created.” <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Jillian Murray',
            job: 'Partner, Advisory'
        },
        images: [
            {
                media: 'Jillian_Murray_1',
                type: 'image'
            },
        ],
    },
    VanessaHogg: {
        title: 'Crunching more than just numbers',
        body: [
            `<em class=em>You can crunch more than just numbers. Work at a place that supports your holistic well-being.</em>`,
            `At Doane Grant Thornton, vital isn’t just a buzzword—it’s an essential part of achieving an amazing life and rewarding career. Since joining the firm two years ago, Vanessa has come to appreciate that creating an environment that supports and promotes all aspects of well-being—physical, mental, emotional, and spiritual—is an important cultural value for us. 
            “The number of resources we have really encourages us to take care of ourselves,” she says. One of her favourite perks is the Vital Wellness benefit, which allows colleagues to expense a variety of well-being benefits. Vanessa uses this benefit for her gym membership which helps her stay focused on what truly matters—staying vital and healthy. `,
            `Beyond the gym, Vanessa takes care of her mental and emotional health by listening to audiobooks, meditating, and diving into creative projects that spark joy. She values our flexible summer policies, which let her work remotely and enjoy the outdoors. “It has a really good benefit on the mind and soul,” she explains. 
            For Vanessa, social connection is also key to staying vital. Her close relationships with colleagues have grown beyond the office, becoming a valued part of her life. “Working at Doane Grant Thornton really incorporates all these different aspects of well-being, providing me with the energy and focus I need to accomplish my goals!” <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Vanessa Hogg',
            job: 'Accountant, Independent Business Group'
        },
        images: [
            {
                media: 'Vanessa_Hogg_2',
                type: 'image'
            },
        ],
    },
    DanielCabral: {
        title: 'Embracing belonging',
        body: [
            `<em class=em>A great culture starts with great relationships. We're proud to provide a workplace built on authentic connections.</em>`,
            `When he showed up at a career fair wearing a purple tie, Daniel Cabral had no idea that decision would lead to some incredible relationships. “It was a lucky coincidence that I wore my purple tie that day,” he says. “A member of the team pointed to me and jokingly said, ‘Boom, you’re hired.’” That led to a long conversation and, a year later, a role in our Advisory practice.
            Now an Associate in our Edmonton office, Daniel continues to be amazed by the authentic connections he’s made: “What really impressed me is the team’s openness and friendliness, and how much they genuinely seemed to enjoy working here. I always remembered that, and when the opportunity came to work here, I jumped at it.”`,
            `As part of a close-knit team, Daniel enjoys the collaboration and camaraderie in the office, as well as the relationships he’s built. “I’m a Level 1 associate, and my colleague, who’s a Level 2, sits right beside me. It’s so helpful to have him here in person, to be able to ask questions. It’s made a huge difference in how quickly I’ve been able to learn.”`,
            `He also likes the variety of work, and networking opportunities that allow him to connect with clients. “Getting to work in different industries and learn our clients’ businesses has been really exciting. Building those relationships is what I enjoy most.”
            Daniel’s grateful he chose to wear purple that day. “My first impression of Doane Grant Thornton—that everyone was genuinely excited to be at the Firm—was definitely the right one. Working with colleagues who always have my back, and who are open to answering questions and helping me learn has really had a positive impact on my life.” <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Daniel Cabral',
            job: 'Associate, Transactions'
        },
        images: [
            {
                media: 'Daniel_Cabral_2',
                type: 'image'
            },
        ],
    },
    KeelyDyment: {
        title: 'Embracing belonging',
        body: [
            `<em class=em>Celebrate your unique story with us. We strive to foster a culture of belonging where you can be your truest self.</em>`,
            `With just one year of post-secondary education under her belt, Keely Dyment joined Doane Grant Thornton in 2022 as a co-op in our Summerside office on Prince Edward Island. It’s the firm’s focus on helping colleagues grow, along with its culture of belonging that encouraged Keely to return for her next two placements.`,
            `“I’ve always felt included and valued by my colleagues,” she says. “They’ve invited me to lunches and social events, even when I was back in school. Not only has everyone been welcoming, but they’ve also shown a genuine interest in my Mi’kmaq culture—they’ve participated in sessions, and they’ve embraced the culture themselves.”`,
            `This sense of belonging has allowed Keely to bring her whole self to work and share her culture and diverse life experiences. When presented with the chance to showcase her ancestral First Nations dance, she eagerly embraced the opportunity. “The jingle dress dance is considered a healing ceremony,” she says. “A lot of times people will request a dance when a loved one is sick or if they think their community or another community could use the prayer. There are 365 jingles on the dress to represent each day of the year.” <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Keely Dyment',
            job: 'Co-op, Assurance'
        },
        images: [
            {
                media: 'Keely_Dyment_2',
                type: 'image'
            },
        ],
    },
}

const allStories = [
[
    {
        slug: 'holistic-well-being',
        theme: 'two-photo',
        title: 'Embracing compassion and silence',
        body: [
            `Connecting authentically with the people around her is vital to Raina’s wellbeing. It’s the first thing that attracted her to Doane Grant Thornton after graduating from the University of Toronto – she was inspired reading about our people on our website and absolutely loved connecting with professionals from all levels at one of our recruiting events. “At that point I knew there wasn’t anywhere else I wanted to be,” she says. “Pursuing my CPA, CA at Doane Grant Thornton has been such an amazing journey, but getting my designation wasn’t my sole focus. It’s more about how I can grow professionally, but also creatively and personally.” And Raina takes every opportunity to do all three. She’s been a mentor for high school students through our program with Junior Achievement Central Ontario, been inspired by some of her not-for-profit clients that impact communities around the world, and learned a lot from her seniors, managers and partners about how important compassion and resilience are in leadership. And she always keeps her eyes open for more opportunities to enhance her wellbeing and that of those around her.`,
            `“It’s not just about getting the job done,” she says. “It’s more about the experience. I don’t close any doors that could open up whole different experiences for me. By connecting and sharing what I’ve learned with the people around me, I find out about all these different things I can do next. There’s so much to look forward to, which is pretty exciting.” <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Raina Kamdar',
            job: 'Manager, Assurance'
        },
        images: [
            {
                media: 'Raina_Kamdar_1',
                type: 'image'
            },
            {
                media: 'Raina_Kamdar_2',
                type: 'image'
            }
        ],
        nav: {
            next: 'our-people'
        }
    },
    {
        slug: 'holistic-well-being',
        theme: 'two-photo',
        title: 'Going off the grid',
        body: [
            `<em class=em>When we focus on well-being, we all thrive. Doane Grant Thornton is proud to provide an environment where colleagues flourish.</em>`,
            `In our digitally focused world, sometimes it pays to go off the grid. Unplugging from technology and spending time in nature is how Harman Sidhu recharges and nourishes his well-being. `,
            `When he moved to Canada 12 years ago from India, Harman was excited to explore our natural landscape. “I started with smaller hikes around Calgary,” he says, “and then moved onto longer backpacking trips. Through my wellness benefits, I was able to buy more backpacking gear, which can get expensive.”`,
            `He recently completed the West Coast Trail, which spans 75-kilometres on Vancouver Island. While often challenging, the eight-day trek offers lush rainforests, windswept sandy beaches, and breath-taking views. “Camping on the beach and falling asleep to the sound of the waves—there’s nothing like it.”`,
            `Harman has taken the firm’s focus on holistic well-being to heart and encourages everyone to make wellness a priority. “It’s so important to take time for yourself and do things that you love. Doane Grant Thornton gives me the flexibility and support I need to pursue my passions.” <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Harman Sidhu',
            job: 'Manager, Independent Business Group'
        },
        images: [
            {
                media: 'Harman_Sidhu_1',
                type: 'image'
            },
            {
                media: 'Harman_Sidhu_2',
                type: 'image'
            }
        ],
        nav: {
            next: 'our-people'
        }
    },
    
], [

    {
        slug: 'belonging',
        theme: 'two-photo',
        title: 'Finding belonging in a new city',
        body: [
            `Moving to a new city to start a new job during a pandemic may sound scary, but that’s exactly what Javiera Bascur did in January 2022 when she moved from Kelowna to Vancouver to start a new role at Doane Grant Thornton. `,
            `Although she didn’t know anyone in the city, at work she was able to take advantage of some of the many ways Doane Grant Thornton supports relationship building at the Firm. As with all new hires, she was assigned a “buddy”, who could guide her and answer any questions she had as she settled into her new role. Her new colleagues even offered to help her move as she set up her new apartment, which instantly made her feel at ease. `,
            `Getting to know her colleagues beyond the office was encouraged at the Firm. Regular team meetings to catch up and connect with others meant she was able to build valuable relationships with her colleagues and create a sense of trust with the team.`,
            `Thanks to the Firm’s commitment to flexibility, Javiera has worked in Doane Grant Thornton’s offices in Vancouver, Toronto, and Kelowna, allowing her to make authentic connections and learn from colleagues across the country. Moving to Vancouver and starting a new job has pushed her out of her comfort zone but having the support of the Firm and colleagues that have made her feel like she belongs, has made all the difference. <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Javiera Bascur',
            job: 'Senior Accountant, Assurance'
        },
        images: [
            {
                media: 'Javiera_Bascur_1',
                type: 'image'
            },
            {
                media: 'Javiera_Bascur_2',
                type: 'image'
            },
        ],
        nav: {
            prev: 'holistic-well-being',
            next: 'authentic-connection-and-trust'
        }
    },
    {
        slug: 'belonging',
        theme: 'two-photo',
        title: 'A place to call home',
        body: [
            `As a citizen of the world, born in Korea, raised in China and attending international schools, Annie Sun was searching for somewhere to belong – a place to call home. She found both in our Doane Grant Thornton Toronto office. `,
            `Starting her new role in the middle of a global pandemic, and unable to see her parents for four years as a result, making authentic connections at work became all the more important. Even before her first day at Doane Grant Thornton, her newly assigned buddy reached out to welcome her to the Firm, and her People Manager checked in on her every day.`,
            `Taking part in our Diverse Exchanges program, Annie was matched with senior colleagues in different parts of the Firm and was able to exchange stories and experiences and get to know them on a personal level. Becoming a mentor for Junior Achievement helped connect her with fellow colleagues who also want to give back to their communities.`,
            `Offering our people a safe space where they can bring their whole selves to work. Creating a sense of belonging so that they’re inspired to be their best and empowered to succeed. <strong>That&rsquo;s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Annie Sun',
            job: 'Manager, Assurance'
        },
        images: [
            {
                media: 'Annie_Sun_1',
                type: 'image'
            },
            {
                media: 'Annie_Sun_2',
                type: 'image'
            },
        ],
        nav: {
            prev: 'holistic-well-being',
            next: 'authentic-connection-and-trust'
        }
    },

], [
    
    {
        slug: 'authentic-connection-and-trust',
        theme: 'two-photo',
        title: 'Colleagues have my back',
        body: [
            `Although Allie started her Doane Grant Thornton career in Tax, she quickly found that Audit was more her thing. She felt more challenged by the engagements, loved working on collaborative teams with her colleagues, and enjoyed speaking with clients and visiting their operations to make the connections and see the impact she was having on their businesses. It brought her career to life. The best part is, even though she’s learning heaps every day, she feels comfortable saying, “I don’t know,” when she’s uncertain about how to proceed. That’s because Allie’s surrounded by colleagues who are willing to put aside what they’re working on to answer her questions and help her whenever she needs it.`,
            `“There’s no judgement about not knowing the answer,” she says. “That makes it easy to ask the question, even if it’s an obvious one. I’ve found my place and it’s great to feel comfortable with the people around you. Because of our authentic connection, I trust them and I know they’re there for me.” <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Allie Mercer',
            job: 'Senior Accountant, Assurance'
        },
        images: [
            {
                media: 'Allie_Mercer_1',
                type: 'image'
            },
            {
                media: 'Allie_Mercer_2',
                type: 'image'
            }
        ],
        nav: {
            prev: 'belonging',
            next: 'award-wining-culture'
        }
    },
    
]
]

const studentStories = [...allStories].map((stories, x) => {
    if (x === 0) { // holistic
        return [
            ...stories,
            {
                ...people.VanessaHogg,
                slug: 'holistic-well-being',
                theme: 'one-photo',
                nav: {
                    next: 'our-people'
                }
            }
        ] 
    }
    if (x === 1) { // belonging
        return [
            ...stories,
            {
                ...people.KeelyDyment,
                slug: 'belonging',
                theme: 'one-photo',
                nav: {
                    prev: 'holistic-well-being',
                    next: 'authentic-connection-and-trust'
                }
            }
        ] 
    }
    if (x === 2) { // authentic
        return [
            ...stories,
            {
                ...people.DanielCabral,
                slug: 'authentic-connection-and-trust',
                theme: 'one-photo',
                nav: {
                    prev: 'belonging',
                    next: 'award-wining-culture'
                }
            }
        ] 
    }
    return stories
})

const experiencedStories = [...allStories].map((stories, x) => {
    if (x === 1) {
        return [
            ...stories,
            {
                ...people.JillianMurray,
                slug: 'belonging',
                theme: 'one-photo',
                nav: {
                    prev: 'holistic-well-being',
                    next: 'authentic-connection-and-trust'
                }
            }
        ]
    }
    return stories
})

export default {
    student: studentStories,
    experienced: experiencedStories,
}